import React from 'react';

const NotFound = () => {
    return (
        <section className="mm-404-error-section-wrapper">
            <div className="mm-404-error-section">
                {/* <!-- abstract red particles (random positions) --> */}
                <div className="mm-404-particle mm-404-p1"></div>
                <div className="mm-404-particle mm-404-p2"></div>
                <div className="mm-404-particle mm-404-p3"></div>
                <div className="mm-404-particle mm-404-p4"></div>
                <div className="mm-404-particle mm-404-p5"></div>
                <div className="mm-404-particle mm-404-p6"></div>

                {/* <!-- subtle background text element --> */}
                <div className="mm-404-bg-pattern">⚠️ ⌛ █ █ █</div>

                {/* <!-- main 404 content --> */}
                <div className="mm-404-glitch-wrapper">
                    <span className="mm-404-error-code">404</span>
                </div>
                
                <h2 className="mm-404-oops-title">ACCESS DENIED • MUTUAL LOST</h2>
                
                <div className="mm-404-description">
                    ⛔ The PAGE you're looking for has collapsed into the crimson void. 
                </div>

                <a href="/" class="mm-404-red-btn">
                    <span>⟡ RETURN TO HOME</span>
                    <i>→</i>
                </a>

                <div className="mm-404-lost-signal">
                    ⚡ ERROR 404 — SIGNAL CORRUPTED ⚡
                </div>
            </div>
        </section>
    );
};

export default NotFound;